import { CARD_WIDTH, Column, EmptyPlaceholder, MediaStack, OutlinedCard, Text } from "@bridgesplit/ui";
import { hasVaultDisclosures, useVaultDisclosures } from "@bridgesplit/abf-react";

import {
    AuditCard,
    DisclaimerBanner,
    DocumentationCard,
    OnChainAddressCard,
    OnChainAddressItem,
    RiskCardList
} from "./risk";

export default function VaultRiskTab({
    vaultAddress,
    onChainAddresses
}: {
    vaultAddress: string | undefined;
    onChainAddresses: OnChainAddressItem[] | undefined;
}) {
    const { data, isLoading, isError } = useVaultDisclosures({ vaultAddress });

    if (isError) {
        return (
            <OutlinedCard spacing={1} padding={2}>
                <Text variant="body2" color="caption">
                    Risk disclosures could not be loaded. Please try again later.
                </Text>
            </OutlinedCard>
        );
    }

    const hasDisclosures = hasVaultDisclosures(data);

    return (
        <Column spacing={4}>
            {data?.disclaimer && <DisclaimerBanner message={data.disclaimer} />}
            <MediaStack spacing={3} sxAbove={{ alignItems: "flex-start" }}>
                <Column sx={{ flex: 1, minWidth: 0 }}>
                    {!isLoading && !hasDisclosures ? (
                        <OutlinedCard padding={2}>
                            <EmptyPlaceholder header="No vault disclosures available" />
                        </OutlinedCard>
                    ) : (
                        <RiskCardList risks={data?.risks} />
                    )}
                </Column>
                <Column spacing={2} sx={{ flex: 1, maxWidth: CARD_WIDTH, minWidth: 0 }}>
                    <OnChainAddressCard addresses={onChainAddresses} />
                    <AuditCard audits={data?.audits} />
                    <DocumentationCard docs={data?.documentation} />
                </Column>
            </MediaStack>
        </Column>
    );
}
